import { api } from "api/api";
import { AxiosError } from "axios";
import MetaProducao from "model/meta/producao/MetaProducao";

export default class MetaProducaoDashboardService {
    buscarMetas(data: string) {
        return new Promise<MetaProducao[]>((resolve, reject): void => {
            api
                .get(`/metaProducao/dashboard/metasPorDia?data=${encodeURIComponent(data)}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    buscarMeta(idMetaOperacao: number) {
        return new Promise<MetaProducao>((resolve, reject): void => {
            api
                .get(`/metaProducao/dashboard/meta/${idMetaOperacao}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }
}